"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const package_json_1 = __importDefault(require("../package.json"));
const { sha, static_path: staticPath } = window.habitnest || {};
const devApiUrl = 'https://habitnest-dev.herokuapp.com/api/v1/';
const debug = {
    logrocket: null,
    sentry: null,
    staticPath: LOCAL_API
        ? '//127.0.0.1:8000/static'
        : 'https://habitnest-dev.s3.amazonaws.com/static',
    // API_URL: LOCAL_API ? 'http://127.0.0.1:8000/api/v1/' : devApiUrl,
    API_URL: devApiUrl,
    version: package_json_1.default.version,
    showsAPIBodies: true,
    stripePubKey: 'pk_test_5cBaMWPJjvzYK0GgCOffERJV',
    googleClientId: '631654177382-7ik8s9thmid46553fs3sa2vp0jt57e4i.apps.googleusercontent.com',
    appleClientId: "com.habitnest.webapp",
    appleRedirectUrl: LOCAL_API ? "https://local.habitnest.com" : "https://habitnest-dev.herokuapp.com",
    crossmintApiKey: "sk_test.dpnbU32e.K5tdyo9xVukJ4Sb5EIHvtdLAN1U9TfHM",
    airbridgeAppName: "habitnestdebug",
    airbridgeWebToken: "d33bc1852d814be09c4943868457b05d"
};
const staging = {
    logrocket: {
        token: '',
        showReportingButton: true,
        sha,
    },
    sentry: {
        token: 'https://d18f3ced9d51429ba07f705151f36901@o14401.ingest.sentry.io/5442746',
        environment: 'staging'
    },
    staticPath: staticPath ? staticPath.slice(0, -1) : '',
    API_URL: 'https://habitnest-stg.herokuapp.com/api/v1/',
    version: package_json_1.default.version,
    showsAPIBodies: false,
    stripePubKey: 'pk_test_5cBaMWPJjvzYK0GgCOffERJV',
    googleClientId: '631654177382-7ik8s9thmid46553fs3sa2vp0jt57e4i.apps.googleusercontent.com',
    appleClientId: "com.habitnest.webapp",
    appleRedirectUrl: "https://habitnest-stg.herokuapp.com",
    crossmintApiKey: "sk_test.dpnbU32e.K5tdyo9xVukJ4Sb5EIHvtdLAN1U9TfHM",
    airbridgeAppName: "habitnestdebug",
    airbridgeWebToken: "d33bc1852d814be09c4943868457b05d"
};
const production = {
    logrocket: {
        token: '',
        showReportingButton: false,
        sha,
    },
    sentry: { token: '', environment: 'production' },
    staticPath: staticPath ? staticPath.slice(0, -1) : '',
    API_URL: 'https://habitnest-prd.herokuapp.com/api/v1/',
    showsAPIBodies: false,
    stripePubKey: 'pk_live_msqrVXm6CLPZIjcFxB7BeJU5',
    googleClientId: '631654177382-7ik8s9thmid46553fs3sa2vp0jt57e4i.apps.googleusercontent.com',
    appleClientId: "com.habitnest.webapp",
    appleRedirectUrl: "https://app.habitnest.com",
    crossmintApiKey: "sk_live.8Lx8ZlRW.pdEo0hlVkIcY2nTw6N4rrkS5Lkv1xqmb",
    airbridgeAppName: "habitnest",
    airbridgeWebToken: "58a7369261b543d5bf4f2c08789605a9"
};
const configs = {
    debug,
    staging,
    production,
};
// @ts-ignore
const environment = configs[process.env.NODE_ENV || 'debug'];
if (!environment) {
    /* eslint-disable */
    console.error('No config file found.  Defaulting to debug');
    /* eslint-enable */
}
const config = environment || debug;
exports.default = config;
